import React from "react";
import S from "./PasswordProtect.styled";

export interface PasswordProtectProps {
  onSubmit: (password: string) => void;
  wrongPw?: boolean;
}

const PasswordProtect: React.FC<PasswordProtectProps> = ({
  onSubmit,
  wrongPw,
}) => {
  const [password, setPassword] = React.useState("");

  const handleClick = () => {
    onSubmit(password);
  };

  return (
    <S.Section>
      <S.Overlay />
      <S.Container>
        <S.Title>Den här kursen är lösenordsskyddad.</S.Title>
        <S.Text>
          Vänligen ange lösenordet nedan för att få tillgång till
          kursmaterialet.
        </S.Text>
        <S.ButtonsWrapper>
          <S.Label htmlFor="password">Lösenord</S.Label>
          <S.Input
            type="password"
            name="password"
            placeholder="Lösenord"
            onChange={(e) => setPassword(e.target.value)}
          />
          {wrongPw && (
            <S.WrongPassword>Fel lösenord, försök igen.</S.WrongPassword>
          )}
          <S.Button onClick={handleClick}>Logga in</S.Button>
        </S.ButtonsWrapper>
      </S.Container>
    </S.Section>
  );
};

export default PasswordProtect;
